// extracted by mini-css-extract-plugin
module.exports = {"red":"src-modules-booking-components-CheckDate-styles__red","yellow":"src-modules-booking-components-CheckDate-styles__yellow"};